import { CountUp } from 'countup.js';
import Helper from './Helper';

class CounterInSwiper {
  constructor(config = {}) {
    const {
      keyfigureInstance,
      langArray,
      decimalArray,
      thousandSepArray
    } = config;
    
    const home = document.querySelector('[class*="home"]');

    if(!!home){
      this.classIn = 'is-in-viewport';
      this.classOut = 'is-not-in-viewport';
  
      this.options = {
        startVal: 0, // number to start at (0)
        decimalPlaces: 0, // number of decimal places (0)
        duration: 4, // animation duration in seconds (2)
        useEasing: false,
        decimal: '',
        separator: ''
      };

      // handle multilang separators and decimals
      langArray.forEach((lang, index) => {
        if (document.documentElement.lang == lang) {
          this.options.decimal = decimalArray[index];
          this.options.separator = thousandSepArray[index];
        }
      });

      this.handleScroll();

      window.addEventListener("scroll", e => {
        this.handleScroll();
      });
      keyfigureInstance.on('slideChangeTransitionEnd', () => {
        this.handleScroll();
      });
    }
  }


  handleScroll(){
    this.numberObj = [];
    this.numbers = document.querySelectorAll('.swiper-slide-visible .ns-keyfigure__number');
    this.numbersArray = Array.prototype.slice.call(this.numbers);
    this.numberObj = this.addNumbersToArray(this.numberObj, this.numbersArray);
    this.numbersArray.forEach((item, index)=>{
      this.addClassOnScroll(item, index, this.classIn, this.classOut);
      if(Helper.hasClass(item, 'is-in-viewport')){
        //console.log('hasClass');¨
        if(!Helper.hasClass(item, 'counting')){
          Helper.addClass(item, 'counting');
          this.options.decimalPlaces = this.getDecimal(item);
          const countUp = new CountUp(item, this.numberObj[index], this.options);
          
          countUp.start();
        }
      }
    });
  }
  
  addClassOnScroll(element, classIn, classOut){
    if (!Helper.isInViewportKeyfigure(element)) {
      element.classList.add(classIn);
      Helper.removeClass(element, classOut);
    } else {
      Helper.removeClass(element, classIn);
      Helper.addClass(element, classOut);
    }
  }

  getDecimal(item){
    //console.log(item);
    const a = item.innerText.split(this.decimal);
    let decimal = 0;
    if(a[1] != undefined){
      decimal = 1;
      if(a[1].toString().length === 2){
        decimal = 2;
      }
    }
    return decimal;
  }
  
  addNumbersToArray(obj, arr){
    arr.forEach((item)=>{
      let anumber = Number(item.innerHTML.replace('’', ''));
      obj.push(anumber);
    });
    return obj;
  }

} export default CounterInSwiper;
